<div class="myaccount-modal">
    <div class="modal-dialog myaccount-modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">Gestion du profil</h2>
            </div>
            <div class="modal-body">
                <app-pharmacie-edit (formSended)="formSended($event)" [sendFormEvent]="sendFormSubject.asObservable()"></app-pharmacie-edit>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-giphar" (click)="closeModal()">Annuler</button>
                <button type="button" class="btn btn-giphar" (click)="sendForm()">Modifier</button>
            </div>
            <div class="container modal-contact-support">
                <p>Pour modifier les champs grisés, veuillez contacter le support en <span (click)="afficherModalContactSupport()">cliquant ici</span></p>
            </div>
        </div>
    </div>
</div>


<app-contact-support-modal
    *ngIf="afficherContactSupport"
    (modalContactSupport)="changeAfficherContactSupport($event)"
    [sendFormEvent]="sendContactSupportFormSubject.asObservable()"
>
</app-contact-support-modal>